import { render } from "./ProductLenta.vue?vue&type=template&id=f5952b4c&scoped=true"
import script from "./ProductLenta.vue?vue&type=script&lang=js"
export * from "./ProductLenta.vue?vue&type=script&lang=js"

import "./ProductLenta.vue?vue&type=style&index=0&id=f5952b4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f5952b4c"]])

export default __exports__